import { render, staticRenderFns } from "./promotionView.vue?vue&type=template&id=7d9d6eca"
import script from "./promotionView.vue?vue&type=script&lang=js"
export * from "./promotionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports